module.exports = __webpack_public_path__ + "img/caja.54074cc4.jpg";